module.exports = __webpack_public_path__ + "static/media/kneenetic-4.d61369d3.jpg";